import { useForm } from '@mantine/form'
import { modals } from '@mantine/modals'
import { notifications } from '@mantine/notifications'

import { useRemoveEmailDomainFromUserMutation } from '../api/emailDomain.api'

interface RemoveEmailDomainFromUserPropsUserCase {
  userEmailDomainId: string
}

interface RemoveEmailDomainFromUserUserCase {
  removeEmailDomain: () => void
  isLoading: boolean
}

const removeEmailDomainFromUserUseCase = ({
  userEmailDomainId,
}: RemoveEmailDomainFromUserPropsUserCase): RemoveEmailDomainFromUserUserCase => {
  const [removeEmailDomainFromUser, { isLoading }] =
    useRemoveEmailDomainFromUserMutation()

  const form = useForm({
    mode: 'uncontrolled',
    initialValues: {},
  })

  const removeEmailDomain = () => {
    form.onSubmit(async () => {
      removeEmailDomainFromUser({ id: userEmailDomainId })
        .unwrap()
        .then(() => {
          modals.closeAll()
          notifications.show({
            title: 'Success',
            message: 'Email domain successfully removed!',
          })
        })
        .catch(() => {
          notifications.show({
            title: 'Error',
            message: 'There was an error try to remove the email domain',
            color: 'red',
          })
        })
    })()
  }

  return {
    removeEmailDomain,
    isLoading,
  }
}

export default removeEmailDomainFromUserUseCase
